<div class="d-flex flex-column" >
  <div class=" col-auto">
    <div class="form-group">
        <div class="form-row">
          <div class="col-2">
            <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
            dropdownPosition='bottom' placeholder="Perimètre" (change) = "perimetreChange()"
              [items]="targetTypes" [multiple]="false"
              [bindLabel]="'label'"
              [closeOnSelect]="true" bindValue="code" [(ngModel)]="selectedTargetType"
              name="targetTypes">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.label}}
            </ng-template>
            </ng-select>
        </div>
        <div class="col-3">
          <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
          dropdownPosition='bottom' placeholder="Element"
            [items]="targets" [multiple]="true"
            [bindLabel]="'label'"
            [closeOnSelect]="false" bindValue="id" [(ngModel)]="selectedTarget"
            name="selectTarget">
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.label}}
          </ng-template>
          </ng-select>
        </div>
          <div class="col-md-6 col-6">
            <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()"
            placeholder="Rechercher dans la Map" autocorrect="off" autocapitalize="off"
            spellcheck="off" type="text" #search>
        </div>
    </div>
  </div>
  <div class="d-flex">
    <div class="col-auto" style="height:400px; overflow-y: scroll;padding-left: 0px;">
      <div *ngFor="let place of lstPlaces"  [ngClass]="{'active': place.active}">
        <!-- <div> -->
          <div class="d-flex flex-column mb-2 card" (click)="centerMapTo(place)">
            <div class="p-2 col">
              <ng-container *ngIf="place.street">
                <i ><span class="material-icons ">room</span>
                  {{place.street}}</i>
              </ng-container>
              <ng-container *ngIf="!place.street">
                <i> <span class="material-icons ">local_police</span>
                  {{place.firstname + ' '+ place.name}}</i>
              </ng-container>

            </div>
            <ng-container *ngIf="place.street">
              <div class="col d-inline">Etat : {{place.busy? 'Occupée': 'Libre'}}</div>
            </ng-container>
            <ng-container *ngIf="!place.street">
              <div class="col d-inline">Etat : {{place.latitude || place.longitude? 'Localisé':'Localosation Indisponible'}}</div>
            </ng-container>
          </div>
      </div>
    <!-- </ng-container> -->
    </div>
    <div class="container flex-grow-1">
      <div #map style="height:400px"></div>
    </div>
  </div>
</div>
